const getCurrentUserImages = () => {
  let fileUrl =localStorage.getItem("fileUrl");
  return fileUrl;
};

export default getCurrentUserImages;
